import styled from 'styled-components';
import { screenSm } from 'constants/styles/breakpoints';

export const FlexColumn = styled.div<{ $gap?: number; $gapSm?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => `${$gap ?? 5}px`};

  ${screenSm} {
    gap: ${({ $gapSm }) => `${$gapSm ?? 12}px`};
  }
`;

export const StyledRadioWrapper = styled.label<{
  $variant: 'simple' | 'card';
  $checked: boolean;
}>`
  display: flex;
  gap: 7px;
  cursor: pointer;
  align-items: flex-start;

  ${({ $variant, $checked, theme }) =>
    $variant === 'card' &&
    `
      padding: 10px;
      border-radius: 12px;
      border: 2px solid ${$checked ? 'var(--lilac)' : 'transparent'};
      background: ${$checked ? 'var(--fog-15)' : 'var(--white)'};
    `}

  input[type='radio'] {
    appearance: none;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.default.colors.palette.Business_LightThemeGreyLighter};
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    outline: none;
    cursor: pointer;
  }

  input[type='radio']::after {
    content: '';
    width: 10px;
    height: 10px;
    background-color: ${({ theme }) => theme.default.colors.palette.Business_DataVizLilacLighter};
    border-radius: 50%;
    display: block;
    transform: scale(0);
    transition: transform 0.2s ease-in-out;
  }

  input[type='radio']:checked::after {
    transform: scale(1);
  }

  ${({ $variant, theme }) =>
    $variant === 'card' &&
    `
      input[type='radio'] {
        border: 2px solid #E5E5EA;
        background-color: #F7F6FF;
      }

      input[type='radio']:checked {
        border-color: ${theme.default.colors.palette.Business_DataVizLilacLighter};
        background-color: #FFFFFF;
      }
    `}
  &:not(:has(input:checked)):hover {
    border-radius: 7px;
    border: 2px solid var(--grey-lighter);
    background: var(--grey-lighter-50);
  }
`;

export const OptionLabel = styled.div<{ $variant: 'simple' | 'card' }>`
  color: #1a2535;
  font-weight: ${({ $variant }) => ($variant === 'card' ? 700 : 400)};
  font-size: 14px;
  line-height: 20px;
`;

export const OptionDescription = styled.div`
  color: var(--light-gray-darker);
  font-size: 12px;
  line-height: 14px;
  margin-top: 3px;
`;

export const OptionMeta = styled.div`
  color: var(--dark-gray);
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
`;
